var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0008 0H8.00078V2H12.6008L6.30078 8.3L7.70078 9.7L14.0008 3.4V8H16.0008V1C16.0008 0.4 15.6008 0 15.0008 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16H1C0.4 16 0 15.6 0 15V2C0 1.4 0.4 1 1 1H5V3H2V14H13V11H15V15C15 15.6 14.6 16 14 16Z",
    fill: "currentColor"
  })));
};
export default SvgExternalLink;